import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const Contact = () => {
  const { t } = useTranslation();
  const form = useRef();
  const [phone, setPhone] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_75cs6uu",
        "template_utzh2r8",
        form.current,
        "u1wuKXtCpvYlyM7p3"
      )
      .then(
        () => {
          alert(t("contact.success"));
          form.current.reset();
          setPhone(""); // telefonu da temizle
        },
        (error) => {
          alert(t("contact.error"));
          console.error(error);
        }
      );
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div
        className="relative flex-grow bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/assets/contact_bg.png')" }}
      >
        <div className="absolute inset-0 bg-black/50 z-0" />

        <div className="relative z-10">
          <Navbar logo={process.env.PUBLIC_URL + "/assets/logo-black.png"} />

          <div className="pt-28 px-4 pb-12 max-w-6xl mx-auto text-white grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 p-6">
              <h2 className="text-3xl font-bold mb-6 border-b border-blue-500 pb-2">
                {t("contact.title")}
              </h2>

              <form ref={form} onSubmit={sendEmail} className="space-y-6 text-white">
                <div>
                  <label className="block font-semibold mb-1 text-sm">
                    {t("contact.name")}
                  </label>
                  <input
                    type="text"
                    name="user_name"
                    placeholder={t("contact.name")}
                    required
                    className="w-full p-3 rounded-xl bg-white/80 text-black shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-semibold mb-1 text-sm">
                    {t("contact.email")}
                  </label>
                  <input
                    type="email"
                    name="user_email"
                    placeholder={t("contact.email")}
                    required
                    className="w-full p-3 rounded-xl bg-white/80 text-black shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
  <label className="block font-semibold mb-1 text-sm">
    {t("contact.phone")}
  </label>
  <PhoneInput
    country={"tr"}
    preferredCountries={["tr"]}
    value={phone}
    onChange={setPhone}
    enableAreaCodes={true}
    enableLongNumbers={true}
    formatOnInit={true}
    autoFormat={true}
    inputStyle={{
      width: "100%",
      paddingLeft: "58px",
      paddingTop: "12px",
      paddingBottom: "12px",
      borderRadius: "12px",
      backgroundColor: "rgba(255,255,255,0.8)",
      color: "black",
      fontWeight: "500",
      border: "1px solid #ccc",
    }}
    buttonStyle={{
      backgroundColor: "rgba(255,255,255,0.8)",
      borderTopLeftRadius: "12px",
      borderBottomLeftRadius: "12px",
      borderRight: "1px solid #ccc",
    }}
    dropdownStyle={{
      backgroundColor: "white",
      color: "black",
      borderRadius: "12px",
      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
    }}
    containerStyle={{ width: "100%" }}
  />
  {/* EmailJS'e gönderilen gizli input */}
  <input
  type="hidden"
  name="user_phone"
  value={
    parsePhoneNumberFromString("+" + phone)?.formatInternational() || ""
  }
/>

</div>

                <div>
                  <label className="block font-semibold mb-1 text-sm">
                    {t("contact.subject")}
                  </label>
                  <input
                    type="text"
                    name="subject"
                    placeholder={t("contact.subject")}
                    required
                    className="w-full p-3 rounded-xl bg-white/80 text-black shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-semibold mb-1 text-sm">
                    {t("contact.message")}
                  </label>
                  <textarea
                    name="message"
                    placeholder={t("contact.message")}
                    required
                    className="w-full p-3 h-32 rounded-xl bg-white/80 text-black shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 hover:scale-[1.02] transition-all duration-200 shadow-md"
                >
                  {t("contact.send")}
                </button>
              </form>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 p-6">
              <h2 className="text-3xl font-bold mb-6 border-b border-blue-500 pb-2">
                {t("contact.infoTitle")}
              </h2>

              <div className="space-y-4 text-white text-base leading-relaxed">
                <p>
                  <strong>{t("contact.addressLabel")}:</strong> Fevzi Çakmak Mahallesi, Muhammet İkbal Caddesi, 10538. Sk. No:17, 42050 Karatay, Konya/TÜRKİYE
                </p>
                <p>
                  <strong>{t("contact.phoneLabel")}:</strong> +90 533 663 93 35 / +90 552 212 04 42
                </p>
                <p>
                  <strong>{t("contact.emailLabel")}:</strong> info@iskocsan.com
                </p>
              </div>

              <div className="mt-6 overflow-hidden rounded-xl border border-white/20 shadow">
                <iframe
                  title="Google Maps"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.3222429517173!2d32.5314061!3d37.9098891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d08fddc4680c3b%3A0xa510f0beb4820428!2zxLAuS0_Dh1NBTiBZYXlsxLEgQXNhbnPDtnIgVGFtcG9ubGFyxLE!5e1!3m2!1str!2sma!4v1746570458887!5m2!1str!2sma"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-64 rounded-xl"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
